var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyApplicationsBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1289 515.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#edeefc;}.b{fill:#dddef6;}.c{fill:#fff;}.d{fill:#c5c9f6;}.e{fill:#e9a4b3;}.f{fill:#22d696;}.g{fill:#0d37c9;}.h{fill:#00a7ff;}.i{fill:#0698e4;}.j{fill:#23c78d;}.k{fill:#d998a9;}.l{fill:#040227;}.m{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 83.425,
    width: 1289,
    height: 432,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 -68.075)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, -4.5, 68.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1280,
    height: 423,
    rx: 4,
    transform: "translate(4.5 86.93)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.851 20.41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M299.267,3.375H43.315A36.564,36.564,0,0,0,6.75,39.94V347.082a36.564,36.564,0,0,0,36.565,36.565H262.7a36.564,36.564,0,0,0,36.565-36.565V3.375Z",
    transform: "translate(614.004 96.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 169.924,
    height: 8.394,
    transform: "translate(681.673 312.601)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 89.205,
    height: 6.009,
    transform: "translate(731.879 176.082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 169.924,
    height: 8.394,
    transform: "translate(681.673 379.789)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162 -6.609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M299.267,3.375H43.315A36.564,36.564,0,0,0,6.75,39.94V347.082a36.564,36.564,0,0,0,36.565,36.565H262.7a36.564,36.564,0,0,0,36.565-36.565V3.375Z",
    transform: "translate(614.004 96.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 169.924,
    height: 8.394,
    transform: "translate(681.673 312.601)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 89.205,
    height: 6.009,
    transform: "translate(731.879 176.082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 169.924,
    height: 8.394,
    transform: "translate(681.673 379.789)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-930.32 -4822.176)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1830.184 4899.758)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2526.469,5444.828s-1.494,14.521-3.133,17.268-8.616,11.523-11.589,13.245,1.815-11.564,1.21-14.15-2.447,4.719-3.757,4.89-.973-6.4-1.02-8.794,6.375-8.3,8.638-13.393S2526.469,5444.828,2526.469,5444.828Z",
    transform: "translate(-2288.836 -5206.372)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2189.844,5177l-3.337-6.3s1.656-11.222-12.4-18.32c0,0-5.139-2.093-8.04,2.1-2.671,3.861,5.092,3.164,4.675,9.768s2.718,10.478,7.082,12.63l3.606,4.177Z",
    transform: "translate(-2130.624 -5072.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2332.014,5168.737s-12.075,59.262-78.52,78.625c-20.742,6.044-67.864-62.242-67.864-62.242s1.657-6.295,12.036-4.85c0,0,45.88,30.375,51.657,33.675,5.126,2.927,38.832-37.638,54.2-44.181A39.211,39.211,0,0,1,2332.014,5168.737Z",
    transform: "translate(-2139.917 -5079.271)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 77.812)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 12.411,
    height: 62.428,
    transform: "translate(13.404 12.267) rotate(-81.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2100.708,5152.879l13.4,8.337,1.884-12.267Z",
    transform: "translate(-2100.708 -5148.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2248.668,5171.728l-.6,3.877a4.369,4.369,0,0,1-4.982,3.656l-2.854-.438,1.884-12.267,3.1.478A4.116,4.116,0,0,1,2248.668,5171.728Z",
    transform: "translate(-2165.128 -5157.078)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.845 223.601)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2579.323,5859.628s8.243,7.523,6.635,12.867-9.047,8.909-10.053,15.441-5.025,10.1-8.644,10.1h-17.254s-2.663-4.6,3.77-5.984,8.859-9.062,8.457-16.187a125.716,125.716,0,0,1,.6-16.629l13.672-3.169Z",
    transform: "translate(-2429.743 -5621.215)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2375.512,5893.146s1.48,17.121-2.14,18.9l-46.313-.095s0-5.345,7.439-6.534,20.507-5.542,22.718-15.243S2375.512,5893.146,2375.512,5893.146Z",
    transform: "translate(-2327.06 -5635.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2344.432,5446.006s2.443,30.009,5.313,66.083c3.9,49,8.6,109.192,9.059,120.6.8,19.8,4.024,51.472,4.024,51.472s7.636,7.525,22.92,4.354c0,0,13.619-45.212,17.509-93.05.061-.783.121-1.575.182-2.363,3.619-48.7,9.246-151.246,9.246-151.246Z",
    transform: "translate(-2335.081 -5429.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2344.432,5446.006s2.443,30.009,5.313,66.083l53.511,83.37c.061-.783.121-1.575.182-2.363,3.619-48.7,9.246-151.246,9.246-151.246Z",
    transform: "translate(-2335.081 -5429.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2365.156,5439.382s44.03,108.682,72.98,159.756,38,65.329,38,65.329,16.586-6.534,18.094-10.987c0,0-11.07-98.6-30.459-122.638-10.955-13.583-23.824-54.341-24.427-68.6s-3.92-42.462-3.92-42.462Z",
    transform: "translate(-2344.649 -5419.784)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2432.49,5114.088s-29.792,14.373-46.966,9.041a40.53,40.53,0,0,1,11.626-9.3c-.595-3.447-1.057-6.438-1.322-8.976a83.114,83.114,0,0,1-.725-9.171l11.492-9.041,10.9-8.65C2416.637,5102.316,2432.49,5114.088,2432.49,5114.088Z",
    transform: "translate(-2232.208 -5038.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2427.093,5292.709c.066,1.821-3.831,3.9-5.549,4.684-12.749,5.594-24.639,9.5-38.113,10.8-15.92,1.627-34.746-1.952-41.219-1.821a2.694,2.694,0,0,1-1.784-.715c-.462-.327-.793-19.513-.462-43.643,0-.976,0-1.951.066-2.928v-.324c.132-9.433.462-19.318.924-29.2.925-21.726,2.643-42.668,5.549-54.245,3.5-13.66,11.428-22.7,18.627-29.271l5.946-5.2a28.572,28.572,0,0,0,18.5-2.209c6.87-3.319,14.267-6.9,15.457-5.987,8.983,6.57,15.06,21.335,18.3,40.2a209.123,209.123,0,0,1,2.709,35.773c0,4.684-.132,9.5-.4,14.245-1.584,25.756,0,48.13.925,61.073C2426.83,5287.7,2427.027,5290.628,2427.093,5292.709Z",
    transform: "translate(-2211.112 -5063.541)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M2456.409,5326.126c-104.32-.209-19.241-113.2-19.241-113.2l16.9-5.489a328.658,328.658,0,0,1,1.958,38.219c0,5-.1,10.146-.288,15.219C2454.594,5288.394,2455.739,5312.3,2456.409,5326.126Z",
    transform: "translate(-2240.956 -5098.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2425.91,5094.71s-7.531,13.725-21.865,17.562a83,83,0,0,1-.726-9.171l11.493-9.04Z",
    transform: "translate(-2240.424 -5045.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2388.826,5070.411s28.42,4.648,31.088-12.822,8.132-28.638-9.9-32.344-22.585,2.435-24.916,8.054S2381.5,5068.751,2388.826,5070.411Z",
    transform: "translate(-2231.172 -5013.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2422.365,5014.048c.258-.3.853-.534,2.177-.607a5.383,5.383,0,0,0-2.474-.7c-.277-1.84-1.257-5.1-4.426-5.893a3.973,3.973,0,0,1,1.926,2.867c-3.671-3.77-11.906-16.388-33.687-14.667-28.7,2.264-13.675,27.248-9.96,29.44s7.873-.549,14.8,0,8.241,10.554,10.589,11.927,1.425-1.054,4.6-2.49,3.48,3.83,2.562,7.253,3.449,7.94,3.449,7.94l4.412-4.752c4.412-4.752,8.572-24.88,6.565-29.171C2422.721,5014.819,2422.546,5014.434,2422.365,5014.048Z",
    transform: "translate(-2223.295 -5004.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2449.255,5132.5s17.982,8.515,26.6,21.6c13.373,20.3,28.875,94.307,29.161,101.158s-11.315,55.231-11.315,55.231-11.766-.774-14.8-6.713c0,0,2.352-49.707.862-52.9s-49.05-66.679-43.7-80.226S2449.255,5132.5,2449.255,5132.5Z",
    transform: "translate(-2255.348 -5063.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2196.886,5176.472s.978-3.863-1.7-5.6-5.144-6.457-6.274-5.818c-2.34,1.325,1.281,5.445.618,10.583C2189.3,5177.438,2193.486,5182.153,2196.886,5176.472Z",
    transform: "translate(-2141.063 -5078.546)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyApplicationsBanner);
export default __webpack_public_path__ + "static/media/my-applications-banner.5866def512b82888a9d686335d22d639.svg";
export { ForwardRef as ReactComponent };